/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Search/theme';

export const SearchTheme = theme;
